import '../styles/LoadingScreen.css'

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-logo">
          <h1>Projet Résurgence</h1>
        </div>
        <div className="loading-spinner"></div>
        <p className="loading-text">Chargement de la carte interactive...</p>
      </div>
    </div>
  )
}

export default LoadingScreen
